import React from 'react';

const ContactUs = () => {
    return (
        <div className="flex justify-center items-center h-screen bg-gray-200">
            <div className="bg-white p-8 rounded-lg shadow-md max-w-md w-full">
                <h1 className="text-3xl font-bold mb-6 text-gray-800">Contact Us</h1>
                <div className="mb-6">
                    <p className="text-gray-700 mb-2 font-semibold">Company:</p>
                    <p className="text-gray-800">Dreams Media and Entertainment</p>
                </div>
                <div className="mb-6">
                    <p className="text-gray-700 mb-2 font-semibold">Address:</p>
                    <p className="text-gray-800">1/769-A, 2nd Floor, Palavanjipalayam Ring Road, Iswarya Nagar, K.Chettipalayam, Land Mark Kalaniyar Arivalayam, Tiruppur - 641608, Tamil Nadu, India.</p>
                </div>
                <div className="mb-6">
                    <p className="text-gray-700 mb-2 font-semibold">Phone:</p>
                    <p className="text-gray-800">(+91) 88389 44844 / (+91) 94433 81952</p>
                </div>
                <div className="mb-6">
                    <p className="text-gray-700 mb-2 font-semibold">Email:</p>
                    <p className="text-gray-800">works@dreamdigitall.com</p>
                </div>
          
            </div>
        </div>
    );
};

export default ContactUs;
